// Module
var code = "<div layout-gt-xs=\"row\">\n    <employees-grid-switch-badges identifier=\"{{$ctrl.identifier}}\"></employees-grid-switch-badges>\n</div>\n\n";
// Exports
module.exports = code;